/** @license React v1.1.1
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var h = require("react"),
    l = Object.getOwnPropertySymbols,
    m = Object.prototype.hasOwnProperty,
    n = Object.prototype.propertyIsEnumerable,
    p = function () {
  try {
    if (!Object.assign) return !1;
    var a = new String("abc");
    a[5] = "de";
    if ("5" === Object.getOwnPropertyNames(a)[0]) return !1;
    var c = {};

    for (a = 0; 10 > a; a++) {
      c["_" + String.fromCharCode(a)] = a;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(c).map(function (b) {
      return c[b];
    }).join("")) return !1;
    var d = {};
    "abcdefghijklmnopqrst".split("").forEach(function (b) {
      d[b] = b;
    });
    return "abcdefghijklmnopqrst" !== Object.keys(Object.assign({}, d)).join("") ? !1 : !0;
  } catch (b) {
    return !1;
  }
}() ? Object.assign : function (a, c) {
  if (null === a || void 0 === a) throw new TypeError("Object.assign cannot be called with null or undefined");
  var d = Object(a);

  for (var b, f = 1; f < arguments.length; f++) {
    var g = Object(arguments[f]);

    for (var k in g) {
      m.call(g, k) && (d[k] = g[k]);
    }

    if (l) {
      b = l(g);

      for (var e = 0; e < b.length; e++) {
        n.call(g, b[e]) && (d[b[e]] = g[b[e]]);
      }
    }
  }

  return d;
};

exports.useSubscription = function (a) {
  var c = a.getCurrentValue,
      d = a.subscribe,
      b = h.useState(function () {
    return {
      getCurrentValue: c,
      subscribe: d,
      value: c()
    };
  });
  a = b[0];
  var f = b[1];
  b = a.value;
  if (a.getCurrentValue !== c || a.subscribe !== d) b = c(), f({
    getCurrentValue: c,
    subscribe: d,
    value: b
  });
  h.useDebugValue(b);
  h.useEffect(function () {
    function b() {
      if (!a) {
        var b = c();
        f(function (a) {
          return a.getCurrentValue !== c || a.subscribe !== d || a.value === b ? a : p({}, a, {
            value: b
          });
        });
      }
    }

    var a = !1,
        e = d(b);
    b();
    return function () {
      a = !0;
      e();
    };
  }, [c, d]);
  return b;
};